webpackJsonp([50],{

/***/ 1071:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_report_cost_sale_vue__ = __webpack_require__(1183);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_310af724_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_report_cost_sale_vue__ = __webpack_require__(1298);
var normalizeComponent = __webpack_require__(193)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_report_cost_sale_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_310af724_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_report_cost_sale_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1102:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_axios__);



// axios.defaults.timeout = 3000
// var TimeoutReq = {timeout: 60 * 5 * 1000}
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_1_axios___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  PrintsendShiftHost: function PrintsendShiftHost(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/pos/send/slip', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  salePosDetail: function salePosDetail(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/pos/daily', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  saleDetail: function saleDetail(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/daily', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  saleCreditDetail: function saleCreditDetail(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/credit/daily', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  saleHoldDetail: function saleHoldDetail(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/holdbill/daily', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  saleSummary: function saleSummary(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/sale/total/daily', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  expenseReport: function expenseReport(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/expense', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  expenseIncome: function expenseIncome(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/income', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  profitReport: function profitReport(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/profit/item/group', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  dailyReport: function dailyReport(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/send/shift', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  stockReport: function stockReport(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/stock/remain', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  movementReport: function movementReport(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/tran/item/section', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  holdingByCus: function holdingByCus(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/holdbill/remain', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  cancelBill: function cancelBill(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/pos/cancel', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  holdingByPaybill: function holdingByPaybill(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/holdbill/paybill/list', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  holdingByRemain: function holdingByRemain(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/pos/list', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  saleType: function saleType(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/sale/total/date', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  saleDocType: function saleDocType(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'sale/v1/report/sale/doctype/date', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  saleByItem: function saleByItem(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/sale/group/begin', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  reportSaleCustomer: function reportSaleCustomer(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/sale/customer', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  reportHoldbillInvoice: function reportHoldbillInvoice(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/holdbill/invoice', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  StandardReport: function StandardReport(URL, header, body, success, error) {
    console.log(body);
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/profit/v2/item/group', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  StandardCostReport: function StandardCostReport(URL, header, body, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post(URL + 'mis/v1/report/item/cost/standard', body, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  }
});

/***/ }),

/***/ 1183:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_service_report__ = __webpack_require__(1102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_service__ = __webpack_require__(511);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      report_data: [],
      startDate: __WEBPACK_IMPORTED_MODULE_1_moment___default()(new Date()),
      endDate: __WEBPACK_IMPORTED_MODULE_1_moment___default()(new Date()),
      header: {
        headers: {
          'Access-Token': sessionStorage.token
        }
      },
      form_data: '',
      branch: 0,
      strucB: [],
      group_item: [],
      group: 0
    };
  },

  methods: {
    getReport: function getReport() {
      var _this = this;

      var branch = 0;
      if (this.branch !== 0) {
        branch = this.branch.id;
      }
      var obj = {
        start_date: this.dateFormatDMY2(this.startDate),
        end_date: this.dateFormatDMY2(this.endDate),
        company_id: 1,
        branch_id: branch,
        item_code: '',
        item_group: this.group === 0 ? '' : this.group.group_code
      };
      this.$store.state.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_2__services_service_report__["a" /* default */].profitReport(sessionStorage.Url, this.header, obj, function (result) {
        _this.$store.state.isLoading = false;
        if (result.response === 'success') {
          _this.report_data = result.data.branch_sub;
          _this.form_data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(result.data.branch_sub);
        } else {
          _this.$notification['warning']({
            message: 'ดึงข้อมูลรายงานไม่ได้',
            description: result.message
          });
        }
      }, function (error) {
        alert('ไม่สามารถเข้าถึงข้อมูล ' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
        _this.$store.state.isLoading = false;
      });
    },
    timeFormat: function timeFormat(str) {
      return __WEBPACK_IMPORTED_MODULE_1_moment___default()(str).format('HH:mm:ss');
    },
    sum_qty: function sum_qty() {
      var sumQty = 0;
      this.report_data.forEach(function (o) {
        if (o['data'] !== null) {
          o['data'].forEach(function (val) {
            val['profit']['sub'].forEach(function (v) {
              sumQty += v['cn_qty'];
            });
          });
        }
      });
      return sumQty;
    },
    sumall_qty: function sumall_qty() {
      var sum = 0;
      this.report_data.forEach(function (o) {
        if (o['data'] !== null) {
          o['data'].forEach(function (val) {
            sum += val['profit']['sum_qty'];
          });
        }
      });
      return sum;
    },
    sumall_avg_cost_sale: function sumall_avg_cost_sale() {
      var sum = 0;
      this.report_data.forEach(function (o) {
        if (o['data'] !== null) {
          o['data'].forEach(function (val) {
            sum += val['profit']['sum_avg_cost_sale'];
          });
        }
      });
      return sum;
    },
    sumall_avg_cost_buy: function sumall_avg_cost_buy() {
      var sum = 0;
      this.report_data.forEach(function (o) {
        if (o['data'] !== null) {
          o['data'].forEach(function (val) {
            sum += val['profit']['sum_avg_cost_buy'];
          });
        }
      });
      return sum;
    },
    sumall_gross_profit: function sumall_gross_profit() {
      var sum = 0;
      this.report_data.forEach(function (o) {
        if (o['data'] !== null) {
          o['data'].forEach(function (val) {
            sum += val['profit']['sum_gross_profit'];
          });
        }
      });
      return sum;
    },
    sumall_gpm: function sumall_gpm() {
      var sum = 0;
      var i = 0;
      this.report_data.forEach(function (o) {
        if (o['data'] !== null) {
          o['data'].forEach(function (val) {
            sum += val['profit']['sum_gpm'];
          });
          i++;
        }
      });
      return sum / i;
    },
    checkSub: function checkSub(obj) {
      var len = 0;
      if (obj !== null) {
        len += obj.profit.sub.length;
      }
      return len;
    },
    checkLastBranch: function checkLastBranch(obj) {
      var len = 0;
      obj.forEach(function (v) {
        if (v['profit']['sub'].length > 0) {
          len++;
        }
      });
      return len;
    },
    total_qty: function total_qty(obj) {
      var sum = 0;
      obj.forEach(function (v) {
        sum += v['profit']['sum_qty'];
      });
      return sum;
    },
    total_gross_profit: function total_gross_profit(obj) {
      var sum = 0;
      obj.forEach(function (v) {
        sum += v['profit']['sum_gross_profit'];
      });
      return sum;
    },
    total_avg_cost_sale: function total_avg_cost_sale(obj) {
      var sum = 0;
      obj.forEach(function (v) {
        sum += v['profit']['sum_avg_cost_sale'];
      });
      return sum;
    },
    total_avg_cost_buy: function total_avg_cost_buy(obj) {
      var sum = 0;
      obj.forEach(function (v) {
        sum += v['profit']['sum_avg_cost_buy'];
      });
      return sum;
    },
    getGroupItem: function getGroupItem() {
      var _this2 = this;

      var obj = {
        'id': 0,
        'company_id': 1,
        'branch_id': 1,
        'begin_date': this.dateFormatDMY2(this.startDate),
        'end_date': this.dateFormatDMY2(this.endDate)
      };
      this.$store.state.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_3__services_service__["a" /* default */].DashBoard(sessionStorage.Url, this.header, obj, function (result) {
        if (result.response === 'success') {
          _this2.$store.state.isLoading = false;
          _this2.Sale_amount = 0;
          _this2.Profit_amount = 0;
          _this2.group_item = [];
          result.data.forEach(function (v) {
            if (v !== null && v.length > 0) {
              v.forEach(function (val) {
                var check = _this2.group_item.findIndex(function (i) {
                  return parseInt(i.group_code) === parseInt(val['group_code']);
                });
                if (check < 0) {
                  _this2.group_item.push(val);
                }
              });
            }
          });
        } else {
          _this2.$store.state.isLoading = false;
          _this2.alert_msg('warning', 'ดึงข้อมูลรายงานไม่ได้', result.message);
        }
      }, function (error) {
        _this2.$store.state.isLoading = false;
        _this2.alert_msg('error', 'ไม่สามารถเข้าถึงข้อมูล', error.message);
      });
    }
  },
  mounted: function mounted() {
    this.checkUser();
    this.getBranch();
    this.getGroupItem();
    // this.getReport()
  }
});

/***/ }),

/***/ 1298:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"card card-solid",style:({ 'min-height': _vm.$store.state.screenHeight - 200 + 'px' })},[_c('div',{staticClass:"card-header pb-0"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group row col-sm-3 pb-0"},[_c('label',{staticClass:"col-sm-4 col-form-label text-right pb-0",attrs:{"for":"date"}},[_vm._v("เลือกสาขา")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8 pb-0"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.branch),expression:"branch"}],staticClass:"custom-select mr-sm-2 pb-0",attrs:{"id":"Host"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.branch=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"0"}},[_vm._v("-- ทุกสาขา --")]),_vm._v(" "),_vm._l((_vm.$store.state.branch_list),function(b,i){return _c('option',{key:'branch' + i,domProps:{"value":b}},[_vm._v(_vm._s(b.branch_name))])})],2)])]),_vm._v(" "),_c('div',{staticClass:"form-group row col-sm-3 pb-0"},[_c('label',{staticClass:"col-sm-4 col-form-label text-right pb-0",attrs:{"for":"date"}},[_vm._v("หมวดหมู่")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8 pb-0"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.group),expression:"group"}],staticClass:"custom-select mr-sm-2 pb-0",attrs:{"id":"Host"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.group=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"0"}},[_vm._v("-- ทุกหมวดหมู่ --")]),_vm._v(" "),_vm._l((_vm.group_item),function(g,i){return _c('option',{key:'gi' + i,domProps:{"value":g}},[_vm._v(_vm._s(g.group_name))])})],2)])]),_vm._v(" "),_c('div',{staticClass:"form-group row col-sm-3 pb-0"},[_c('label',{staticClass:"col-sm-4 col-form-label text-right",attrs:{"for":"date"}},[_vm._v("จากวันที่")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('a-date-picker',{staticStyle:{"width":"100%"},attrs:{"format":'DD/MM/YYYY'},model:{value:(_vm.startDate),callback:function ($$v) {_vm.startDate=$$v},expression:"startDate"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group row col-sm-3 pb-0"},[_c('label',{staticClass:"col-sm-4 col-form-label text-right",attrs:{"for":"date"}},[_vm._v("ถึงวันที่")]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('a-date-picker',{staticStyle:{"width":"100%"},attrs:{"format":'DD/MM/YYYY'},model:{value:(_vm.endDate),callback:function ($$v) {_vm.endDate=$$v},expression:"endDate"}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-2"}),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('button',{staticClass:"btn btn-success btn-block",attrs:{"type":"button"},on:{"click":_vm.getReport}},[_c('i',{staticClass:"fas fa-redo"}),_vm._v(" ประมวลผล\n          ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('form',{attrs:{"action":"/static/pdf/report_cost_sale.php","method":"POST","target":"_blank"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.startDate),expression:"startDate"}],attrs:{"type":"hidden","name":"date_start"},domProps:{"value":(_vm.startDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.startDate=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.endDate),expression:"endDate"}],attrs:{"type":"hidden","name":"date_end"},domProps:{"value":(_vm.endDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.endDate=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form_data),expression:"form_data"}],attrs:{"type":"hidden","name":"data"},domProps:{"value":(_vm.form_data)},on:{"input":function($event){if($event.target.composing){ return; }_vm.form_data=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-block",attrs:{"type":"submit","disabled":_vm.sum_qty() === 0}},[_c('i',{staticClass:"far fa-file-pdf"}),_vm._v(" บันทึกเป็น PDF\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('form',{attrs:{"action":"/static/excel/report_cost_sale.php","method":"POST","target":"_blank"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.startDate),expression:"startDate"}],attrs:{"type":"hidden","name":"date_start"},domProps:{"value":(_vm.startDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.startDate=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.endDate),expression:"endDate"}],attrs:{"type":"hidden","name":"date_end"},domProps:{"value":(_vm.endDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.endDate=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form_data),expression:"form_data"}],attrs:{"type":"hidden","name":"data"},domProps:{"value":(_vm.form_data)},on:{"input":function($event){if($event.target.composing){ return; }_vm.form_data=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-block",attrs:{"type":"submit","disabled":_vm.sum_qty() === 0}},[_c('i',{staticClass:"far fa-file-excel"}),_vm._v(" บันทึกเป็น Excel\n            ")])])])]),_vm._v(" "),_c('div',{staticClass:"table-responsive-sm mt-3"},[_vm._l((_vm.report_data),function(c,i){return _c('table',{directives:[{name:"show",rawName:"v-show",value:(c.data !== null),expression:"c.data !== null"}],key:'c' + i,staticClass:"table"},_vm._l((c.data),function(d,s){return _c('tbody',{key:'d' + s},[(s === 0 && _vm.checkSub(d) > 0)?_c('tr',{staticClass:"text-left"},[_c('th',{staticStyle:{"font-size":"20px"},attrs:{"colspan":"6"}},[_vm._v("\n                สาขา: "+_vm._s(c.branch_name)+"\n              ")])]):_vm._e(),_vm._v(" "),(d.profit.sub.length > 0)?_c('tr',{staticClass:"text-left"},[_c('th',{attrs:{"colspan":"6"}},[_vm._v("\n                หมวดหมู่: "+_vm._s(d.group_name)+"\n              ")])]):_vm._e(),_vm._v(" "),(d.profit.sub.length > 0)?_c('tr',{staticClass:"text-left"},[_c('th',{attrs:{"colspan":"6"}},[_vm._v("\n                "+_vm._s(d.profit.date)+"\n              ")])]):_vm._e(),_vm._v(" "),(d.profit.sub.length > 0)?_c('tr',{staticClass:"thead-dark text-center"},[_c('th',{attrs:{"width":"20%"}},[_vm._v("รหัส: ชื่อ")]),_vm._v(" "),_c('th',{attrs:{"width":"15%"}},[_vm._v("จำนวน")]),_vm._v(" "),_c('th',{attrs:{"width":"10%"}},[_vm._v("มูลค่าขาย")]),_vm._v(" "),_c('th',{attrs:{"width":"10%"}},[_vm._v("มูลค่าทุนชื้อ")]),_vm._v(" "),_c('th',{attrs:{"width":"10%"}},[_vm._v("กำไรขั้นต้น")]),_vm._v(" "),_c('th',{attrs:{"width":"10%"}},[_vm._v("กำไร %")])]):_vm._e(),_vm._v(" "),_vm._l((d.profit.sub),function(sub,i){return _c('tr',{directives:[{name:"show",rawName:"v-show",value:(d.profit.sub.length > 0),expression:"d.profit.sub.length > 0"}],key:'sub' + i},[_c('td',{staticClass:"text-left"},[_vm._v(_vm._s(sub.item_code || '-')+": "+_vm._s(sub.item_name || '-'))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(sub.qty)))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(sub.avg_cost_sale)))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(sub.avg_cost_buy)))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(sub.gross_profit)))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(sub.gpm))+" %")])])}),_vm._v(" "),(d.profit.sub.length > 0)?_c('tr',{staticStyle:{"background":"#f7f7f7"}},[_c('th',{staticClass:"text-left"},[_vm._v("รวม")]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(d.profit.sum_qty)))]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(d.profit.sum_avg_cost_sale)))]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(d.profit.sum_avg_cost_buy)))]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(d.profit.sum_gross_profit)))]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(d.profit.sum_gpm))+" %")])]):_vm._e(),_vm._v(" "),(s === _vm.checkLastBranch(c.data) && _vm.total_qty(c.data) > 0)?_c('tr',{staticStyle:{"background":"#f7f7f7","font-size":"18px"}},[_c('th',{staticClass:"text-left"},[_vm._v("รวมสาขา "+_vm._s(c.branch_name))]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(_vm.total_qty(c.data))))]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(_vm.total_avg_cost_sale(c.data))))]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(_vm.total_avg_cost_buy(c.data))))]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal(_vm.total_gross_profit(c.data))))]),_vm._v(" "),_c('th',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.numberFormatDecimal((_vm.total_gross_profit(c.data) / _vm.total_avg_cost_sale(c.data)) * 100))+" %")])]):_vm._e()],2)}),0)}),_vm._v(" "),_c('table',{staticClass:"table"},[(_vm.sum_qty() !== 0)?_c('tr',{staticStyle:{"background":"#f7f7f7","font-size":"20px"}},[_c('th',{staticClass:"text-left",attrs:{"width":"20%"}},[_vm._v("รวมทุกสาขา")]),_vm._v(" "),_c('th',{staticClass:"text-right",attrs:{"width":"15%"}},[_vm._v(_vm._s(_vm.numberFormatDecimal(_vm.sumall_qty())))]),_vm._v(" "),_c('th',{staticClass:"text-right",attrs:{"width":"10%"}},[_vm._v(_vm._s(_vm.numberFormatDecimal(_vm.sumall_avg_cost_sale())))]),_vm._v(" "),_c('th',{staticClass:"text-right",attrs:{"width":"10%"}},[_vm._v(_vm._s(_vm.numberFormatDecimal(_vm.sumall_avg_cost_buy())))]),_vm._v(" "),_c('th',{staticClass:"text-right",attrs:{"width":"10%"}},[_vm._v(_vm._s(_vm.numberFormatDecimal(_vm.sumall_gross_profit())))]),_vm._v(" "),_c('th',{staticClass:"text-right",attrs:{"width":"10%"}},[_vm._v("\n              "+_vm._s(_vm.numberFormatDecimal((_vm.sumall_gross_profit() / _vm.sumall_avg_cost_sale()) * 100))+" %\n            ")])]):_vm._e()])],2)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/50.3536fb8b97aac4e79d4d.js